module.exports = __webpack_public_path__ + "img/Frame659.0594ff35.svg";